"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsAjaxCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {
      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();
        return false;
      });
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      var sellingPlan = 'false';
      var itemKey = $(this).data('cart-item-key');
      var title = $(this).data('url');

      if (title.includes('selling_plan')) {
        sellingPlan = 'true';
      }
      Shopify.theme.jsAjaxCart.removeFromCart(itemKey, sellingPlan);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(itemKey, sellingPlan);
      }

      return false;
    });
    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();
      return false;
    });
  },
  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $('[data-ajax-cart-trigger]');
    $el.hover(function () {
      $el.addClass('show-mini-cart');
    }, function () {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != 'mini_cart') return false;
    var $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $('.mobile-header [data-ajax-cart-trigger]'); // Removes url to the cart page so user is not redirected

    $el.attr('href', '#');
    $el.off('click').on('click', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      } // Loads content into ajaxCart container for mobile header


      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      $el.toggleClass('show-mini-cart'); // Calculate height of mini cart

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt($('.mobile-header').height());

      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      $('.mobile-header .theme-ajax-cart').css({
        height: "calc(100vh - ".concat(mobileHeaderHeight + announcementHeight, "px)")
      });
    });
  },
  showDrawer: function showDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function hideDrawer() {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function removeFromCart(itemKey, sellingPlan, callback) {

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&id=' + itemKey,
      dataType: 'json',
      success: function success(cart) {
        // let sum_single = 0;
        // let subs = false;

        // cart.items.forEach(item => {
        //   if (item.variant_id !== 36336151265432 && item.variant_id !== 44145691853036 && item.variant_id !== 44134346490092) {
        //     sum_single += item.quantity;

        //     if(item.selling_plan_allocation) {
        //       subs = true;
        //     }
        //   }
        // });

        // if (sum_single < 3) {
        //     let item_val = cart.items.filter(x => x.id == 44134346490092)

        //     if(item_val)
        //         Shopify.theme.quantityBox.updateCart(item_val[0]?.key, 0, '');
        // }

        // if(( itemKey.includes('36336151265432') || itemKey.includes('44134346490092') ) && sellingPlan == 'true' && $(".check_free-gift").val() == '1'){
        //     Shopify.theme.quantityBox.updateCart(44145691853036, 0, '');
        // }
        $('.loader-cart').css('display', 'block');
        $('.ajax-cart__form').css('opacity', '0.2');
        setTimeout(() => {
          $('.loader-cart').css('display', 'none');
          $('.ajax-cart__form').css('opacity', '1');
        }, 1000);
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  initializeAjaxCart: function initializeAjaxCart() {
    Shopify.theme.asyncView.load('/cart', // template name
      'ajax' // view name (suffix)
    ).done(function (_ref) {
      var html = _ref.html,
        options = _ref.options;
      $('[data-ajax-cart-content]').html(html.content);

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () { // some error handling
    });
  },
  initializeAjaxCartOnMobile: function initializeAjaxCartOnMobile() {
    this.toggleMiniCart();
    Shopify.theme.asyncView.load('/cart', // template name
      'ajax' // view name (suffix)
    ).done(function (_ref2) {
      var html = _ref2.html,
        options = _ref2.options;
      $('.mobile-header [data-ajax-cart-content]').html(html.content);

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () { // some error handling
    });
  },
  addToCart: function addToCart($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function success(product) {
        $('.loader-cart').css('display', 'block');
        $('.ajax-cart__form').css('opacity', '0.2');
        setTimeout(() => {
          $('.loader-cart').css('display', 'none');
          $('.ajax-cart__form').css('opacity', '1');
        }, 1000);

        var $el = $('[data-ajax-cart-trigger]');
        $addToCartBtn.find('.checkmark').addClass('checkmark-active');

        function addedToCart() {
          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');
          $addToCartBtn.find('span').removeClass('fadeInDown');
        }

        window.setTimeout(function () {
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
        }, 1000);

        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        if (Shopify.theme.jsCart) {
          var _$$ajax;
          $.ajax((_$$ajax = {
            dataType: "json",
            async: false,
            cache: false
          }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
            var cartForm = $(html).find('.cart__form');
            $('.cart__form').replaceWith(cartForm);
          }), _$$ajax));
        }
      },
      error: function error(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        var cartWarning = "<p class=\"cart-warning__message animated bounceIn\">".concat(response.replace('All 1 ', 'All '), "</p>");
        $('.warning').remove();
        $addToCartForm.find('.cart-warning').html(cartWarning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('span').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');
      }
    });
  },
  customAddToCart: function addToCart(idProduct, selling_plan, qty = 1) {
    const fomdata = {
      quantity: qty,
      id: idProduct,
      selling_plan: selling_plan
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(fomdata),
    })
      .then(response => response.json())
      .then(() => {
        $('.loader-cart').css('display', 'block');
        $('.ajax-cart__form').css('opacity', '0.2');
        setTimeout(() => {
          $('.loader-cart').css('display', 'none');
          $('.ajax-cart__form').css('opacity', '1');
        }, 1000);
        Shopify.theme.jsAjaxCart.updateView();
        Shopify.theme.jsAjaxCart.showDrawer();
      })
      .catch(error => {
        console.error('Erro adding product to cart:', error);
      });
  },
  customAddToCartBulk: function addToCart(fomdata) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(fomdata),
    })
      .then(response => response.json())
      .then(() => {
        $('.loader-cart').css('display', 'block');
        $('.ajax-cart__form').css('opacity', '0.2');
        setTimeout(() => {
          $('.loader-cart').css('display', 'nonde');
          $('.ajax-cart__form').css('opacity', '1');
        }, 1000);
        Shopify.theme.jsAjaxCart.updateView();
        Shopify.theme.jsAjaxCart.showDrawer();
      })
      .catch(error => {
        console.error('Erro adding product to cart:', error);
      });
  },


  updateView: function updateView() {
    Shopify.theme.asyncView.load('/cart', // template name
      'ajax' // view name (suffix)
    ).done(function (_ref3) {
      var html = _ref3.html,
        options = _ref3.options;

      if (options.item_count > 0) {
        var itemList = $(html.content).find('.ajax-cart__list');
        var savings = $(html.content).find('.ajax-cart__savings');
        var subtotal = $(html.content).find('.ajax-cart__subtotal');
        var itemSave = $(html.content).find('.sidecart__goal--milestone.sidecart__goal--saving>span');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__savings').replaceWith(savings);
        $('.ajax-cart__subtotal').replaceWith(subtotal);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

        fetch("/cart.json")
          .then((response) => response.json())
          .then((data) => {
            var current_variants_in_cart = [];
            var flag = 0;
            var itemCount = data.item_count;

            let sum_single = 0;
            let subs = false;

            var idCarritoItems = [];
            var sellingPlanIDCart = [];

            data.items.forEach(item => {
              idCarritoItems.push(item.product_id);
              if (item.selling_plan_allocation) {
                sellingPlanIDCart.push(item.selling_plan_allocation.selling_plan.id);
              }
              if (item.variant_id !== 36336151265432 && item.variant_id !== 44145691853036 && item.variant_id !== 44134346490092) {
                sum_single += item.quantity;

                if (item.selling_plan_allocation) {
                  subs = true;
                }
              }
            });

            $('.product-select-5489893605528').removeClass('hidden');
            $('.product-select-3544999428189').removeClass('hidden');
            $('.product-select-3554956247133').removeClass('hidden');

            var idsBuscados = [3544999428189, 5489893605528, 3554956247133];
            var idsBuscadosTwo = [5780581712024];
            var productosEncontrados = 0;
            data.items.forEach(item => {
              if (idsBuscados.includes(item.product_id)) {
                productosEncontrados++;
                $('.product-select-' + item.product_id + '').addClass('hidden');
              }
              if (item.product_id === idsBuscadosTwo) {
                $('.content-upsell-cart').addClass('hidden');
              } else {
                $('.content-upsell-cart').removeClass('hidden');
              }
              if (productosEncontrados === idsBuscados.length) {
                $('.content-upsell-cart').addClass('hidden');
              } else {
                $('.content-upsell-cart').removeClass('hidden');
              }
            });

            const bundleSearch = data.items.find((product) => product.id === 36336151265432);

            if (bundleSearch) {
              $('.content-upsell-cart').addClass('hidden');
            }


            var textUpdate = 'Save 35%';
            if (sum_single < 3) {
              var textUpdate = 'Save 35%';
            } else if (subs) {
              var textUpdate = 'Save 45%';
            }
            $('.sidecart__goal--milestone.sidecart__goal--saving>span').text(textUpdate);

            data.items.forEach((item, x) => {
              current_variants_in_cart.push(item.variant_id);
            });

            current_variants_in_cart.forEach(element => {
              if (element == '44145691853036') {
                $("[data-variant = 44145691853036]").css("display", "none");
                $(".check_free-gift").val('1');
                flag = 1;
              }
            })

            if (flag == 1) {
              $(".sidecart__goals").html(`<div class="sidecart__goals--progress"><div class="current-progress"></div></div>`);
            } else {
              $(".sidecart__goals").html(`<div class="sidecart__goals--progress"><div class="current-progress"></div></div>`);
            }

            var productosEncontradosSubs = 0;
            let productsSubsCount = 0;
            for (var index in data.items) {
              if (data.items[index].selling_plan_allocation) {
                productsSubsCount = productsSubsCount += data.items[index].quantity;
                productosEncontradosSubs++;
              }
              if (productosEncontradosSubs > 0) {
                if (productosEncontradosSubs == 1) {
                  $(".sidecart__goals-copy p").html(data_customize_cart.subsOneProduct);
                  $(".sidecart__goals-copy span").css('display', 'none');
                  $(".sidecart__goals--progress").html(`<div class="current-progress" style="width: 33.33%"></div>`);

                } else if (productosEncontradosSubs == 2) {
                  $(".sidecart__goals-copy p").html(data_customize_cart.subsTwoProduct);
                  $(".sidecart__goals-copy span").css('display', 'none');
                  $(".sidecart__goals--progress").html(`<div class="current-progress" style="width: 66.66%"></div>`);
                } else if (productosEncontradosSubs >= 3) {
                  $(".sidecart__goals-copy p").html(data_customize_cart.subsThreeProduct);
                  $(".sidecart__goals-copy span").css('display', 'block');
                  $(".sidecart__goals--progress").html(`<div class="current-progress" style="width: 100%"></div>`);
                }
              } else {
                if (itemCount == 1) {
                  $(".sidecart__goals-copy p").html(data_customize_cart.oneTimeTitle);
                  $(".sidecart__goals-copy span").css('display', 'none');
                  $(".sidecart__goals--progress").html(`<div class="current-progress" style="width: 33.33%"></div>`);

                } else if (itemCount == 2) {
                  $(".sidecart__goals-copy p").html(data_customize_cart.oneTimeTitle);
                  $(".sidecart__goals-copy span").css('display', 'none');
                  $(".sidecart__goals--progress").html(`<div class="current-progress" style="width: 33.33%"></div>`);
                } else if (itemCount >= 3) {
                  $(".sidecart__goals-copy p").html(data_customize_cart.oneTimeTitle);
                  $(".sidecart__goals-copy span").css('display', 'block');
                  $(".sidecart__goals--progress").html(`<div class="current-progress" style="width: 33.33%"></div>`);
                }

                if (idCarritoItems.includes(5780581712024)) {
                  $(".sidecart__goals-copy p").html(data_customize_cart.bundleSubsTitle);
                  $(".sidecart__goals-copy span").css('display', 'block');
                  $(".sidecart__goals--progress").html(`<div class="current-progress" style="width: 100%"></div>`);
                }
              }

              if (productsSubsCount == 2) {
                $(".sidecart__goals-copy p").html(data_customize_cart.subsTwoProduct);
                $(".sidecart__goals-copy span").css('display', 'none');
                $(".sidecart__goals--progress").html(`<div class="current-progress" style="width: 66.66%"></div>`);
              } else if (productsSubsCount >= 3) {
                $(".sidecart__goals-copy p").html(data_customize_cart.subsThreeProduct);
                $(".sidecart__goals-copy span").css('display', 'block');
                $(".sidecart__goals--progress").html(`<div class="current-progress" style="width: 100%"></div>`);
              }

              if (idCarritoItems.includes(5780581712024)) {
                $(".sidecart__goals-copy p").html(data_customize_cart.bundleSubsTitle);
                $(".sidecart__goals-copy span").css('display', 'block');
                $(".sidecart__goals--progress").html(`<div class="current-progress" style="width: 33.33%"></div>`);
              }

              if (idCarritoItems.includes(5780581712024) && sellingPlanIDCart.includes(5062754540)) {
                $(".sidecart__goals-copy p").html(data_customize_cart.subsThreeProduct);
                $(".sidecart__goals-copy span").css('display', 'block');
                $(".sidecart__goals--progress").html(`<div class="current-progress" style="width: 100%"></div>`);
              }
            }

            if (productsSubsCount >= 3) {
              $('.content-upsell-cart h3').text('Buy More, Save More');
            } else {
              $('.content-upsell-cart h3').text(data_customize_cart.sectionBundleTitle);
            }

            const $atcBundles = document.querySelectorAll('.custom-atc-bundle');
            $atcBundles.forEach($atcBundle => {
              if ($atcBundle.dataset.initialized === 'true') return; // ✅ evita duplicados
              $atcBundle.dataset.initialized = 'true';

              $atcBundle.addEventListener('click', (event) => {
                const $idProduct = $atcBundle.querySelector('[name="id"]').value;
                const qtyInput = $atcBundle.querySelector('[name="quantity"]');
                const qty = qtyInput ? qtyInput.value : 1;
                let selling_plan = "";
                $atcBundle.parentElement.parentElement.classList.add('hidden');
                Shopify.theme.jsAjaxCart.customAddToCart($idProduct, selling_plan, qty);
              });
            });

            $('.content-edit-subs').on('click', function () {
              $(this).parent().addClass('active-select');
            });

            $('.new-select-custom .select-options li').on('click', function () {
              $('.skio-sidecart.active-select').removeClass('active-select');
            });

            // CHECK FOR GIFTS:
            if (data_free_gift.checboxFreeGift == "true") {
              Shopify.theme.jsAjaxCart.checkForGifts(data);
            }
          })
        Shopify.theme.jsAjaxCart.renderSelect();
      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (Shopify.theme_settings.show_multiple_currencies) {
        convertCurrencies();
      }
    }).fail(function () { // some error handling
    });
  },
  checkForGifts: function checkForGifts(cartData) {
    // Free Gift
    const freeGift = cartData.items.find(lineItem => lineItem.id === 44145691853036);

    const product1 = cartData.items.find(lineItem => lineItem.id === 28169140109405);
    const product2 = cartData.items.find(lineItem => lineItem.id === 28205825228893);
    const product3 = cartData.items.find(lineItem => lineItem.id === 35276794232984);

    let itemCount = 0;


    if (data_free_gift.freeType == "only_subscription") {
      if (product1) {
        if (product1.selling_plan_allocation) {
          itemCount += product1.quantity;
        }
      }
      if (product2) {
        if (product2.selling_plan_allocation) {
          itemCount += product2.quantity;
        }
      }
      if (product3) {
        if (product3.selling_plan_allocation) {
          itemCount += product3.quantity;
        }
      }
    } else if (data_free_gift.freeType == "one_time") {
      if (product1) {
        if (!product1.selling_plan_allocation) {
          itemCount += product1.quantity;
        }
      }
      if (product2) {
        if (!product2.selling_plan_allocation) {
          itemCount += product2.quantity;
        }
      }
      if (product3) {
        if (!product3.selling_plan_allocation) {
          itemCount += product3.quantity;
        }
      }
    } else {
      if (product1) {
        itemCount += product1.quantity;
      }
      if (product2) {
        itemCount += product2.quantity;
      }
      if (product3) {
        itemCount += product3.quantity;
      }
    }

    // Bundle Gift
    const bundleGift = cartData.items.find(lineItem => lineItem.id === 44145691853036);
    const bundle = cartData.items.find(lineItem => lineItem.id === 36336151265432);


    if (itemCount >= 3 && !freeGift && !bundleGift) {
      Shopify.theme.jsAjaxCart.customAddToCart(44145691853036, '', 1);
    }
    if (itemCount < 3 && freeGift && !bundleGift) {
      Shopify.theme.jsAjaxCart.removeFromCart(freeGift.id);
    }

    if (data_free_gift.freeType == "only_subscription" && bundle) {
      let bundleSellingPlan = '';
      if (bundle) {
        bundleSellingPlan = bundle.selling_plan_allocation;
      }
      if (bundleSellingPlan && !bundleGift) {
        Shopify.theme.jsAjaxCart.customAddToCart(44145691853036, '', 1);
      }
      if (!bundleSellingPlan && bundleGift) {
        Shopify.theme.jsAjaxCart.removeFromCart(bundleGift.id);
      }
    } else if (data_free_gift.freeType == "one_time" && bundle) {
      if (bundle.price == 18900 && !bundleGift) {
        Shopify.theme.jsAjaxCart.customAddToCart(44145691853036, '', 1);
      }
      if (bundle.price == 15900 && bundleGift) {
        Shopify.theme.jsAjaxCart.removeFromCart(bundleGift.id);
      }
    } else {
      if (bundle && !bundleGift && !freeGift) {
        Shopify.theme.jsAjaxCart.customAddToCart(44145691853036, '', 1);
      }

      if (!bundle && bundleGift && itemCount < 3) {
        Shopify.theme.jsAjaxCart.removeFromCart(bundleGift.id);
      }
    }
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  },
  renderSelect: async () => {
    let customSelects = $('.hex-select-js select');

    $('.loader-cart').css('display', 'block');
    $('.ajax-cart__form').css('opacity', '0.2');
    setTimeout(() => {
      $('.loader-cart').css('display', 'none');
      $('.ajax-cart__form').css('opacity', '1');
    }, 1000);

    $('.content-new-subs-bundle #subs-only').on('click', function () {
      $('[data-product-id="5780581712024"] [rel="5062754540"]').click();
    });

    $('.content-new-subs-bundle #one-time-only').on('click', function () {
      $('[data-product-id="5780581712024"] .list-item:contains("One time purchase")').click();
    });

    if (customSelects) {
      $('.hex-select-js select').each(function () {
        var $this = $(this);

        $this.addClass('select-hidden');
        $this.wrap('<div class="new-select-custom"></div>');
        $this.after('<div class="select-styled"></div>');

        var $styledSelect = $this.next('div.select-styled');
        $styledSelect.text($this.find('option:selected').text());

        var $list = $('<ul />', {
          'class': 'select-options',
          'data-product-id': $this.data('product-id'),
          'data-cart-item-key': $this.data('cart-item-key'),
          'data-product-qty': $this.data('product-qty')
        }).insertAfter($styledSelect);

        $this.children().each(function () {
          const element = $(this);

          if (element.is('optgroup')) {
            $('<li />', {
              text: element.attr('label'),
              class: 'group-title'
            }).appendTo($list);

            element.children('option').each(function () {
              const option = $(this);

              $('<li />', {
                text: option.text(),
                rel: option.val(),
                class: 'list-item'
              }).appendTo($list);

              if (option.is(':selected')) {
                $('li[rel="' + option.val() + '"]').addClass('is-selected')
              }
            });
          } else {
            $('<li />', {
              text: element.text(),
              rel: element.val(),
              class: 'list-item'
            }).appendTo($list);

            if (element.is(':selected')) {
              $('li[rel="' + element.val() + '"]').addClass('is-selected')
            }
          }
        });

        var $listItems = $list.children('li:not(.group-title)');

        $styledSelect.click(function (e) {
          e.stopPropagation();
          $('div.select-styled.active').not(this).each(function () {
            $(this).removeClass('active').next('ul.select-options').hide();
          });
          $(this).toggleClass('active').next('ul.select-options').toggle();
        });

        $listItems.click(function (e) {
          e.stopPropagation();
          $styledSelect.text($(this).text()).removeClass('active');
          $this.val($(this).attr('rel'));
          $list.find('li.is-selected').removeClass('is-selected');
          $list.find('li[rel="' + $(this).attr('rel') + '"]').addClass('is-selected');

          var dataKey = $this.data("cart-item-key");
          var dataSelling = $this.val();
          var dataQty = $(this).closest('.select-options').data("product-qty");
          var isSidecart = $this.closest('.skio-sidecart').length > 0;
          if (isSidecart)
            updateChangeCart(dataKey, dataSelling, dataQty);

          $list.hide();
        });

        $(document).click(function () {
          $styledSelect.removeClass('active');
          $list.hide();
        });

      });
    }
  },
  initializeIntelligems: async () => {
    const experiments = window.igData?.user.getTestGroup("7e33b3d4-6f76-420c-835a-c22ecff6a5b1");
    return experiments;
  }
};


document.addEventListener('DOMContentLoaded', () => {
  const $atcBundles = document.querySelectorAll('.custom-atc-bundle');
  $atcBundles.forEach($atcBundle => {
    if ($atcBundle.dataset.initialized === 'true') return; // ✅ evita duplicados
    $atcBundle.dataset.initialized = 'true';

    $atcBundle.addEventListener('click', (event) => {
      const $idProduct = $atcBundle.querySelector('[name="id"]').value;
      const qtyInput = $atcBundle.querySelector('[name="quantity"]');
      const qty = qtyInput ? qtyInput.value : 1;
      let selling_plan = "";
      $atcBundle.parentElement.parentElement.classList.add('hidden');
      Shopify.theme.jsAjaxCart.customAddToCart($idProduct, selling_plan, qty);
    });
  });
});